import styled from 'styled-components';
import { Text } from '@zillow/constellation';

export const StyledTourCardDetailsText = styled(Text)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
